import Auth from './auth/reducer';
import App from './app/reducer';
import ThemeSwitcher from './themeSwitcher/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';
import Dashboard from './dashboard/reducer';
import Confirm from './confirm/reducer';
// import Properties from './properties/reducer';
import Properties2 from './properties2/reducer';
import PropertiesAdvertise from './propertiesAdvertise/reducer';
import PropertiesSubscribe from './propertiesSubscribe/reducer';
import PropertiesTenancyAgreements from './propertiesTenancyAgreements/reducer';
import Tenants from './tenants/reducer';
import Issues from './issues/reducer';
import Calendar from './calendar/reducer';
import Mails from './mail/reducer';
import RentVerifications from './outstandingRentVerifications/reducer';
import TenancyAgreements from './propertiesTenancyAgreements/reducer';
import CancelSubscription from './cancelSubscription/reducer';
import Notifications from './notifications/reducer';

export default {
	Auth,
	App,
	ThemeSwitcher,
	LanguageSwitcher,
	Dashboard,
	Confirm,
	// Properties,
	Properties2,
	PropertiesAdvertise,
	PropertiesSubscribe,
	PropertiesTenancyAgreements,
	Tenants,
	Calendar,
	Issues,
	TenancyAgreements,
	Mails,
	RentVerifications,
	CancelSubscription,
	Notifications,
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js